import axios from "../base/axios.js";

const baseUrl = '/longstron/setting/feed/back/manage';

// 新增点评
export function addModel(data) {
  return axios.post(baseUrl, data);
}
